module.exports = __webpack_public_path__ + "img/report-icon-2.9715d75c.png";